import type { Feedback } from 'bundles/connect/types';

export const UPDATE_CALL_CONSOLE_AI_COMPANY_FEEDBACK = 'UPDATE_CALL_CONSOLE_AI_COMPANY_FEEDBACK';
export const UPDATE_OFF_MARKET_PROPERTY_AI_COMPANY_FEEDBACK = 'UPDATE_OFF_MARKET_PROPERTY_AI_COMPANY_FEEDBACK';
export const UPDATE_CALL_CONSOLE_OWNERSHIP_FEEDBACK = 'UPDATE_CALL_CONSOLE_OWNERSHIP_FEEDBACK';
export const UPDATE_OFF_MARKET_PROPERTY_OWNERSHIP_FEEDBACK = 'UPDATE_OFF_MARKET_PROPERTY_OWNERSHIP_FEEDBACK';

export function updateCallConsoleAiCompanyFeedback(aiCompanyId: string, feedback: Feedback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CALL_CONSOLE_AI_COMPANY_FEEDBACK,
      payload: { aiCompanyId, feedback }
    });
  };
}

export function updateOffMarketAiCompanyFeedback(aiCompanyId: string, feedback: Feedback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_OFF_MARKET_PROPERTY_AI_COMPANY_FEEDBACK,
      payload: { aiCompanyId, feedback }
    });
  };
}

export function updateCallConsoleOwnershipFeedback(ownershipId: string, feedback: Feedback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CALL_CONSOLE_OWNERSHIP_FEEDBACK,
      payload: { ownershipId, feedback }
    });
  };
}

export function updateOffMarketOwnershipFeedback(ownershipId: string, feedback: Feedback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_OFF_MARKET_PROPERTY_OWNERSHIP_FEEDBACK,
      payload: { ownershipId, feedback }
    });
  };
}
